import * as z from "zod";

export const FilterItemOptionSchema = z.object({
  id: z.union([z.string(), z.number()]),
  name: z.string(),
});

export const FiltersSchema = z.object({
  discipline: z.array(FilterItemOptionSchema),
  category: z.array(FilterItemOptionSchema),
  country: z.array(FilterItemOptionSchema),
  club: z.array(FilterItemOptionSchema),
});

export type FilterItemOption = z.infer<typeof FilterItemOptionSchema>;
export type Filters = z.infer<typeof FiltersSchema>;
